var render = function render(){var _vm=this,_c=_vm._self._c;return (this.todisplay)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.isvisible),expression:"this.isvisible"}],class:{ 'c-FileDiff': true, [`c-name-${this.name || 'unnamed'}`]: true },style:(_vm.sizeStyle),attrs:{"id":_vm.editorId}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.prettyHtml)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }